import { Component, OnInit } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { Uploads } from '../../../services/uploads';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import * as fuzzball from 'fuzzball';
import firebase from 'firebase';
import { DeliberyNoteServices } from '../../services';
import { IngredientsServices } from '../../../ingredients/services';
import { ProductsServices } from '../../../products/services';
import { DeliberyNoteResultFotoIa } from '../delibery-note-result-foto-ia/delibery-note-result-foto-ia';
import { DeliberyNoteListPage } from '../../delibery-note-list/delibery-note-list';
import { AIServices } from '../../../services/aiServices';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';

/**
 * Generated class for the DeliberyNoteProcessFotoIa page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-delibery-note-process-foto-ia',
  templateUrl: 'delibery-note-process-foto-ia.html',
})
export class DeliberyNoteProcessFotoIa implements OnInit {

  public image_url_delibery_view: Observable<string | null>;
  img_ref: string = null;
  selectedFiles: FileList;
  listProduct = []
  listProvider = [];
  cadenaBusqueda: string = '';
  filteredProducts: any[] = []
  provider_static: string = null;
  date = null;
  number: number = null;
  delibery_note_uid = null;
  json_Response = <any>Promise;

  TotalNoTax: number = 0;



  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public uploadServices: Uploads,
    public http: HttpClient,
    public translate: TranslateService,
    public deliberyNoteServices: DeliberyNoteServices,
    public ingredientsServices: IngredientsServices,
    public productsServices: ProductsServices,
    private alertCtrl: AlertController,
    public aiServices: AIServices) {

    this.img_ref = this.navParams.get('img_ref');
  }

  async ngOnInit() {
    // Obtener la URL de la imagen para mostrarla
    if (this.img_ref) {
      this.getImageUrl(this.img_ref);
    }

    // Procesar la imagen con IA usando el nuevo endpoint
    this.json_Response = await this.AIalbaran();
    if (this.json_Response != false) {
      this.SendDeliberyResultIA();
    }
  }

  // PARA IMPORTAR LOS PRODCUTOS DEL RESTAURANTE 
  async ImportProduct() {

    let list_array_tmp = Array();
    const productsRef = firebase.firestore()
    //improtem products
    await productsRef.collection('products').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        let product = {
          "uid_product": doc.id,
          "type": 'product',
          "name": _doc.name,
          "measurement": _doc.measurement,
          "ean": _doc.ean
        };
        list_array_tmp.push(product);
      });
    });
    //improtem ingredients
    await productsRef.collection('ingredients').where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        let ingredient = {
          "uid_product": doc.id,
          "type": 'ingredient',
          "name": _doc.name,
          "measurement": _doc.measurement,
          "ean": ""
        };
        list_array_tmp.push(ingredient);
      });
    });

    return list_array_tmp
  }

  // PARA IMPORTAR LOS PROVEEDORES  DEL RESTAURANTE 
  async ImportProvider() {
    let list_array_tmp = Array();
    const providerRef = firebase.firestore().collection('providers');
    await providerRef.where('UID_RESTAURANT', '==', this.globals.restaurant_uid).get().then(snapshot => {
      snapshot.forEach(doc => {
        var _doc = doc.data();
        let product = {
          "uid_provider": doc.id,
          "provider_static": _doc.name,
        };
        list_array_tmp.push(product);
      });
    });
    return list_array_tmp
  }

  getImageUrl(image_ref) {
    //Get image url for show . Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
    const ref = this.uploadServices.storage.ref(image_ref);
    this.image_url_delibery_view = ref.getDownloadURL();
  }

  async getUrlForVision(image_ref): Promise<string> {
    //obtiene la url de la observable y la convierte en promesa para obtener la url 
    let ref = await this.uploadServices.storage.ref(image_ref);
    let url = ref.getDownloadURL().toPromise();
    return url
  }

  async processImageWithDocumentAI() {
    if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
      try {
        // Obtener la URL de la imagen
        const imageUrl = await this.getUrlForVision(this.img_ref);

        // Enviar la URL al endpoint de analytics_path
        const body = {
          'fileUrl': imageUrl,
          'processorVersion': 'dea1d52eb3f65a8a'
        }

        return new Promise((resolve, reject) => {
          this.http.post(this.globals.analytics_path + 'google/document-ai/process', body, {})
            .subscribe(
              (res: any) => {
                resolve(res);
              },
              (error) => {
                console.error('Error procesando imagen con IA:', error);
                resolve(false);
              }
            );
        });
      } catch (err) {
        console.error('Error en processImageWithAI:', err);
        return false;
      }
    }
    return false;
  }

  // Métodos de limpieza de JSON ya no son necesarios con el nuevo endpoint
  // El servidor devuelve JSON limpio directamente

  // Helper function for padding numbers
  padStart(str: string, targetLength: number, padString: string): string {
    if (str.length >= targetLength) {
      return str;
    }
    const pad = padString.repeat(targetLength);
    return pad.slice(0, targetLength - str.length) + str;
  }

  // FUNCION DE MAPEADO FUERA DE LA CLASE Y ANTES DE LOS IMPORTS
  mapDocumentAIToOldFormat(data: any): any {
    const mapped: any = {
      date: data.invoice_date || '',
      number: data.invoice_id || '',  // ✅ Usar invoice_id del nuevo formato
      name: data.supplier_name || '',
      nif: data.supplier_tax_id || data.x_id || '',
      provider_static: data.supplier_name || '',
      uid_provider: '',
      address: data.supplier_address || '',
      email: data.supplier_email || '',
      phone: data.supplier_phone || '',
      list: [],
      waiter: data.waiter || '',
      total: data.total_amount || 0,  // ✅ Usar total_amount del nuevo formato
      tax: data.total_tax || 0,  // ✅ Usar total_tax del nuevo formato
      subtotal: data.subtotal || 0,  // ✅ Nuevo campo
      _metadata: data._metadata || {}  // ✅ Guardar metadata para debugging
    };

    if (Array.isArray(data.line_items)) {
      mapped.list = data.line_items.map(item => {
        // El nuevo endpoint ya envía campos parseados como números
        let name = item.description || item._raw_value || item._value || '';
        let quantity = typeof item.quantity === 'number' ? item.quantity : parseFloat(String(item.quantity || '0').replace(',', '.'));
        let price = typeof item.unit_price === 'number' ? item.unit_price : parseFloat(String(item.unit_price || '0').replace(',', '.'));
        let total = typeof item.amount === 'number' ? item.amount : parseFloat(String(item.amount || '0').replace(',', '.'));
        let tax = typeof item.tax === 'number' ? item.tax : parseFloat(String(item.tax || '0').replace(',', '.'));
        let discount = typeof item.discount === 'number' ? item.discount : parseFloat(String(item.discount || '0').replace(',', '.'));

        // Si no hay nombre, intentar con product_code
        if (!name && item.product_code) name = item.product_code;

        return {
          name,
          quantity: quantity || 0,
          price: price || 0,
          total: total || 0,
          tax: tax || 0,
          discount: discount || 0,
          reference: item.product_code || '',
          ean: item.ean || '',  // ✅ Nuevo: EAN si lo extrae el endpoint
          lots: '',
          measurement: item.unit || 'ud.',  // ✅ Usar unidad del endpoint
          type: 'ingredient',  // Por defecto, se ajustará en el matching
          type_discount: 'discount_percentage',
          _raw_value: item._raw_value || ''  // ✅ Para debugging
        };
      });
    }

    // Si el backend no calculó totales, calcularlos
    if (!mapped.total && mapped.list.length > 0) {
      mapped.total = mapped.list.reduce((acc, prod) => acc + (prod.total || 0), 0);
    }
    
    return mapped;
  }

  // FUNCION AI PARA BUSCAR LOS PRODCUTOS DEL ALABRAN 
  async AIalbaran() {
    if (this.globals.checkLimitsByLicense('dishes', 'ai')) {
      try {
        // Usar el nuevo endpoint en lugar del prompt de DeepSeek
        const result = await this.processImageWithDocumentAI();
        if (result && result !== false) {
          let json_Response = this.mapDocumentAIToOldFormat(result);
          //Añadimos que esta generado por IA
          json_Response.waiter = `Generado por IA a traves de ${this.globals.user_name}`;

          //checkeamos el albaran generado por IA
          await this.CheckProductIADeliveryNote(json_Response);
          await this.CheckAttributeIADeliveryNote(json_Response);
          return json_Response;
        } else {
          throw new Error('No se pudo procesar la imagen');
        }
      } catch (error) {
        let alert = await this.alertCtrl.create({
          title: this.translate.instant('articulos-alert-timeout-title'),
          message: error.message || this.translate.instant('articulos-alert-timeout-text'),
          buttons: [
            {
              text: this.translate.instant('general-aceptar'),
              role: 'cancel',
              handler: () => {
              }
            },
          ]
        });
        await alert.present();
        this.navCtrl.push(DeliberyNoteListPage);
        return false;
      }
    } else {
      this.navCtrl.push(AddonsTriggerVersionProPage);
    }
  }

  // enviar los datos para mostrar a la tabla de resultados
  SendDeliberyResultIA() {
    this.navCtrl.push(DeliberyNoteResultFotoIa, {
      json_Response: this.json_Response,
      isIA: true
    });
  }

  // chekamos los nombres que no tengan un uid prodcut o que lo tengan para que busque los prodcutos con cadena de texto 
  async CheckProductIADeliveryNote(json_Response) {
    let Strings = await this.ImportProduct();

    try {
      for (let i = 0; i < json_Response.list.length; i++) {
        let matchFound = false;

        // ✅ PASO 1: Intentar match exacto por EAN (si el endpoint lo envía)
        if (json_Response.list[i].ean && json_Response.list[i].ean !== '') {
          const eanMatch = Strings.find(s => s.ean && s.ean === json_Response.list[i].ean);
          if (eanMatch) {
            this.assignProductMatch(json_Response.list[i], eanMatch);
            matchFound = true;
            continue;
          }
        }

        // ✅ PASO 2: Intentar match exacto por referencia (product_code)
        if (json_Response.list[i].reference && json_Response.list[i].reference !== '') {
          const refMatch = Strings.find(s => {
            // Algunos productos pueden tener referencias en otros campos, añadir lógica aquí si es necesario
            return s.reference && s.reference.toLowerCase() === json_Response.list[i].reference.toLowerCase();
          });
          if (refMatch) {
            this.assignProductMatch(json_Response.list[i], refMatch);
            matchFound = true;
            continue;
          }
        }

        // ✅ PASO 3: Normalizar texto para fuzzy matching
        let Query = this.normalizeText(json_Response.list[i].name);

        // ✅ PASO 4: Fuzzy matching con token_sort_ratio (mejor para palabras desordenadas)
        let OptionsFuzz = {
          scorer: fuzzball.token_sort_ratio,  // CAMBIO: mejor que ratio para palabras desordenadas
          processor: choice => this.normalizeText(choice.name),  // CAMBIO: normalizar antes de comparar
          limit: 3,  // CAMBIO: obtener top 3 para elegir mejor (aunque solo usemos el primero)
          cutoff: 65,  // CAMBIO: bajado de 80 a 65 para mayor tolerancia
          unsorted: false
        };

        var results = await fuzzball.extract(Query, Strings, OptionsFuzz);

        if (results.length > 0) {
          // Tomar el mejor resultado
          var choiceObjects = results.map(result => result[0]);
          const bestMatch = choiceObjects[0];
          const confidence = results[0][1];  // Score de confianza (0-100)

          this.assignProductMatch(json_Response.list[i], bestMatch);
          matchFound = true;
          
          // Si la confianza es baja (65-75%), marcar para posible revisión manual
          if (confidence < 75) {
            json_Response.list[i]._needsReview = true;
            json_Response.list[i]._matchConfidence = confidence;
            json_Response.list[i]._alternatives = results.slice(0, 3).map(r => ({
              name: r[0].name,
              score: r[1],
              uid: r[0].uid_product || r[0].uid_ingredient,
              type: r[0].type
            }));
          }
        }

        if (!matchFound) {
          // Dejar uid_product vacío para que el usuario lo seleccione manualmente
          json_Response.list[i]._needsReview = true;
          json_Response.list[i]._matchConfidence = 0;
        }
      }
      return json_Response;
    } catch (error) {
      console.error('[CheckProductIADeliveryNote] Error:', error);
      return json_Response;  // CAMBIO: devolver json_Response en vez de "invalid json"
    }
  }

  // ✅ MÉTODO AUXILIAR: Normalizar texto (quitar acentos, minúsculas, espacios extra)
  normalizeText(text: string): string {
    if (!text) return '';
    return text
      .toLowerCase()
      .normalize('NFD').replace(/[\u0300-\u036f]/g, '')  // Quitar acentos
      .replace(/\s+/g, ' ')  // Múltiples espacios → 1 espacio
      .trim();
  }

  // ✅ MÉTODO AUXILIAR: Asignar match encontrado al item
  assignProductMatch(item: any, match: any) {
    item.uid_product = match.uid_product;
    item.name = match.name;  // Usar el nombre del catálogo (normalizado)
    item.measurement = match.measurement;
    item.ean = match.ean || '';
    item.type = match.type;
    
    // Si es ingrediente, necesita uid_ingredient en vez de uid_product
    if (match.type === 'ingredient') {
      item.uid_ingredient = match.uid_product;  // En ImportProduct, ambos usan uid_product temporalmente
      // No eliminamos uid_product aquí porque se usa en IngredientToProduct()
    }
  }

  // chekeamos el date para convertirlo a timestamp
  CheckDateIADeliveryNote(json_Response) {
    const dateStr = json_Response.date;

    if (!dateStr) return dateStr;

    try {
      // If it's already in YYYY-MM-DD format
      if (dateStr.includes('-')) {
        return dateStr; // Return the original string, no need to convert
      }

      // If it's in DD/MM/YYYY format
      if (dateStr.includes('/')) {
        const [day, month, year] = dateStr.split('/').map(num => parseInt(num, 10));
        return `${year}-${this.padStart(String(month), 2, '0')}-${this.padStart(String(day), 2, '0')}`;
      }

      return dateStr; // If no conversion needed, return as is
    }
    catch (error) {
      return dateStr;
    }
  }

  // chekeamos que solo existe measurments que estan en MCT
  CheckMeasurementDeliberyNote(json_Response) {
    const validMeasurements = ['fl', 'gal', 'kg', 'l', 'lb', 'oz', 'pint', 'ud.'];

    for (let i = 0; i < json_Response.list.length; i++) {
      if (validMeasurements.indexOf(json_Response.list[i].measurement) === -1) {
        json_Response.list[i].measurement = 'ud.';
      }
      if (json_Response.list[i].measurement === 'ud.') {
        json_Response.list[i].quantity = Math.floor(parseFloat(json_Response.list[i].quantity));
      }
    }

    return json_Response;
  }

  // chekeamos los attributos para que tengan su formato
  async CheckAttributeIADeliveryNote(json_Response) {
    // atrributos para list
    const numberPattern = /\d+([.,]\d+)?/;

    //hacemos un objeto para los tipos que necestamos que deben ser en integer
    function checkNumberProperties(obj) {
      return {
        price: typeof (obj.price) === 'number',
        tax: typeof (obj.tax) === 'number',
        quantity: typeof (obj.quantity) === 'number',
        discount: typeof (obj.discount) === 'number',
        total: typeof (obj.total) === 'number'
      };
    }

    try {
      //ponemos la funcion date ya que es un atrributo
      json_Response.date = await this.CheckDateIADeliveryNote(json_Response);
      await this.CheckMeasurementDeliberyNote(json_Response);

      if (json_Response.list.length > 0) {
        //comprobamos el json para que valide que los attributos de list esta en su tipo de formato y si no lo pueda cambiar
        for (let i = 0; i < json_Response.list.length; i++) {
          const propertyCheck = checkNumberProperties(json_Response.list[i]);
          //chekeamos los attributos
          Object.keys(propertyCheck).forEach(key => {
            if (!propertyCheck[key]) {
              let rawValue = json_Response.list[i][key].toString().replace(',', '.');
              const match = rawValue.match(numberPattern);
              if (match) {
                json_Response.list[i][key] = parseFloat(match[0]);
              }
              else { json_Response.list[i][key] = undefined }
            }
          });
        }
      }
      return json_Response
    }
    catch { return "invalid json" }
  }

}


// WEBPACK FOOTER //
// ./src/pages/delibery_note/delibery-note-create/delibery-note-process-foto-ia/delibery-note-process-foto-ia.ts